module.exports = __webpack_public_path__ + "static/media/jupiler.fa7d605b.jpg";